import React, { useState, useRef } from "react";
import "./styles.css";
import ReactDOM, { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import PopUpAlert from "componentes/General/PopUps/PopUpAlerta";
import { urlServidor } from "helpers";
import conektaHelper from "../../../../../helpers/conekta";
import FetchAPI from "@renedelangel/helpers/lib/FetchAPI";
import closeSVG from "./iconoPopUpLogin/close.svg";
import LoaderLogoSoftwone from "_layout/assets/svg/Animaciones/logoSoftwone";
import Validaciones from "@renedelangel/helpers/lib/Validaciones";
import { rgxNombre } from "helpers/regexp";



const {trim} = Validaciones;

export default function AgregarTarjetas(props) {
    let {
        open,
        actualizar,
        stateActualizar,
        propsSetAlert,
        propsSetOpenAlert
    } = props;
    const { usuario, token } = useSelector(state => state.login);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    const clearState = {
        nameCard: "",
        cardNumber: "",
        expMonth: "",
        expYear: "",
        cvv: ""
    };

    const [state, setState] = useState(clearState);
    const [alert, setAlert] = useState({
        mensaje: "",
        titulo: ""
    });
    const [openAlert, setOpenAlert] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);

    async function conektaGenerarToken() {
        setLoading(true);
        conektaHelper.initConekta();

        if (!rgxNombre.test(nameCard) || trim(nameCard) === '') {
            setAlert({
                mensaje: "Verifica el nombre del tarjetahabiente",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateCardNumber(state.cardNumber)) {
            setAlert({
                mensaje: "Verifique el número de la tarjeta",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (expMonth == "") {
            setAlert({
                mensaje: "Debe seleccionar un mes",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (expYear == "") {
            setAlert({
                mensaje: "Debe seleccionar un año",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateExpirationDate(expMonth, expYear)) {
            setAlert({
                mensaje: "Valida la vigencia del año y mes",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateCvc(cvv)) {
            setAlert({
                mensaje: "Debe registrar un cvv valido",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        conektaHelper.initConekta();
        let AuxVencimiento = [state.expMonth, state.expYear];
        conektaHelper.tokenize(
            state.cardNumber,
            state.nameCard,
            AuxVencimiento[0],
            AuxVencimiento[1],
            state.cvv,
            AgregarTarjeta,
            errorTokenConekta
        );
        ///Hasta aquí si se generó el token de conekta correctamente, se contnua en la función TokenConektaGenerado, sino se continua en el errorTokenConekta.
    }

    async function AgregarTarjeta(TokenConekta) {
        setDisabled(true);
        let resultado = await FetchAPI.send({
            url: `${urlServidor}/Conekta/AgregarTarjeta`,
            params: {
                usuarioID: JSON.stringify(usuario.usuarioID),
                tokenConekta: JSON.stringify(TokenConekta),
                state: JSON.stringify(state),
                datosUsuario: JSON.stringify({
                    nombre: usuario.nombre,
                    correo: usuario.correo
                })
            }
        });

        // setLoader(false);
        if (resultado.ok == true) {
            setLoading(false);
            propsSetAlert({
                titulo: "¡Exito!",
                mensaje: "Se ha registrado de forma correcta la tarjeta"
            });
            propsSetOpenAlert(true);
            actualizar(!stateActualizar);
            open(false);
        } else {
            setLoading(false);
            setAlert({
                titulo: "error",
                mensaje:
                    "Ha ocurrido un error al registrar la tarjeta, vuelva a intentarlo"
            });
            setOpenAlert(true);
            setDisabled(false);
        }
    }

    function errorTokenConekta(token) {
        setLoading(false);
        setAlert({
            mensaje: 'Revisa tu información',
            title: "Problemas al generar el token"
        });
        setOpenAlert(true);
    }

    async function stop() {
        setState(clearState);
        await delay(3000);
        setOpenAlert(false);
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setState(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    let { nameCard, cardNumber, expMonth, expYear, cvv } = state;

    return ReactDOM.createPortal(
        <>
            <div
                className="contenedorGeneralAgregarTarjetas"
                onClick={() => {
                    open(false);
                }}
            >
                <div
                    className="contenedorInternoAgregarTarjetas"
                    onClick={e => e.stopPropagation()}
                >
                    <div
                        className="c_cerrar_lista_tarjetas"
                        onClick={() => {
                            open(false);
                        }}
                    >
                        <img src={closeSVG} />
                    </div>

                    <div className="tituloAgregarTarjetas">
                        <h3>Datos de la tarjeta</h3>
                    </div>

                    <form className="formTarjetas">
                        <div className="contenedorNombreTarjeta">
                            <label htmlFor={"nameCard"}>
                                Nombre de tarjetahabiente
                            </label>
                            <input
                                id={"nameCard"}
                                placeholder="Nombre"
                                name="nameCard"
                                value={nameCard}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                        </div>
                        <div className="contenedorNumeroTarjeta">
                            <label htmlFor="numeroTarjetaID">
                                Número de tarjeta
                            </label>
                            <input
                                className="numeroTarjeta"
                                id="numeroTarjetaID"
                                type="tel"
                                inputMode="numeric"
                                pattern="[0-9\s]{13,19}"
                                autoComplete="cc-number"
                                maxLength="19"
                                placeholder="XXXX - XXXX - XXXX - XXXX"
                                name="cardNumber"
                                value={cardNumber}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                        </div>

                        <div className="agrupadorDatos">
                            <div className="contenedorFechaTarjeta">
                                <label>Fecha de vencimiento</label>
                                <div className="agrupadorFechas">
                                    <div className="agrupadorMesTarjeta">
                                        <select
                                            className="mesTarjeta"
                                            name="expMonth"
                                            value={expMonth}
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        >
                                            <option value={""} disabled>
                                                {" "}
                                                Seleccione el mes
                                            </option>
                                            <option
                                                value={"01"}
                                                selected="selected"
                                            >
                                                01
                                            </option>
                                            <option value={"02"}>02</option>
                                            <option value={"03"}>03</option>
                                            <option value={"04"}>04</option>
                                            <option value={"05"}>05</option>
                                            <option value={"06"}>06</option>
                                            <option value={"07"}>07</option>
                                            <option value={"08"}>08</option>
                                            <option value={"09"}>09</option>
                                            <option value={"10"}>10</option>
                                            <option value={"11"}>11</option>
                                            <option value={"12"}>12</option>
                                        </select>
                                    </div>
                                    <div className="agrupadorYearTarjeta">
                                        <select
                                            className="yearTarjeta"
                                            name="expYear"
                                            value={expYear}
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        >
                                            <option value={""} disabled>
                                                Seleccione el año
                                            </option>
                                            <option
                                                value={"22"}
                                                selected="selected"
                                            >
                                                2022
                                            </option>
                                            <option value={"23"}>2023</option>
                                            <option value={"24"}>2024</option>
                                            <option value={"25"}>2025</option>
                                            <option value={"26"}>2026</option>
                                            <option value={"27"}>2027</option>
                                            <option value={"28"}>2028</option>
                                            <option value={"29"}>2029</option>
                                            <option value={"30"}>2030</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                           
                        </div>

                        <div className="agrupadorCvv">
                                <label htmlFor="cvvTarjeta">Código de seguridad</label>
                                <input
                                    id="cvvTarjeta"
                                    className="cvvTarjeta"
                                    maxLength={3}
                                    placeholder="CVV"
                                    name="cvv"
                                    value={cvv}
                                    onChange={e => {
                                        handleChange(e);
                                    }}
                                />
                            </div>
                    </form>

                    <button
                        onClick={() => {
                            conektaGenerarToken();
                        }}
                        className="buttonSubmitAddTarjeta"
                        disabled={disabled}
                    >
                        Agregar tarjeta
                    </button>
                </div>
            </div>

            {openAlert ? (
                <PopUpAlert
                    mensaje={alert.mensaje}
                    titulo={alert.titulo}
                    open={setOpenAlert}
                />
            ) : (
                <></>
            )}

            {loading ? <LoaderLogoSoftwone /> : <></>}
        </>,
        document.getElementById("alert")
    );
}
